'use client';

import { PdfViewer } from '@bw/elements';
import { useAppContext } from '@bw/ui';
import type { CSSProperties } from 'react';
import styles from './PdfSection.module.scss';

export function PdfSectionViewer({ url, title }: { url: string; title: string }) {
	const { announcementBannerHeight } = useAppContext();

	const announcementHeight = {
		'--announcement-banner-height': `${announcementBannerHeight}px`,
	} as CSSProperties;

	return (
		<div className={styles.viewerWrapper} style={announcementHeight}>
			<PdfViewer url={url} title={title} fallbackHref={url} className={styles.viewer} />
		</div>
	);
}
